export default [{

        title: 'Classfeed',
        route: 'classfeed',
        resource: 'Classfeed',
        action: 'read',
        // icon: 'ClassBoardIcon',
        icon: 'TrelloIcon'

    },
    {

        title: 'Discipline Regulations',
        // route: 'teacherguidepdf',
        target: '_blank',
        href: 'https://n.thebes-school.com//apps/teachersguide.pdf',
        // path: '/apps/teachersguide.pdf',
        resource: 'Discipline Regulations',
        action: 'read',
        // icon: 'ClassBoardIcon',
        icon: 'TrelloIcon'

    },
    
    
     {

        title: 'Announcements',
        route: 'announcements',
        resource: 'Classfeed',
        action: 'read',
        // icon: 'ClassBoardIcon',
        icon: 'TrelloIcon'

    },
    {

        title: 'My Certificates',
        route: 'mycertificates',
        resource: 'mycertificates',
        action: 'read',
        icon: 'TrelloIcon'

    },
    {

        title: 'Certificates',
        route: 'certificates',
        resource: 'certificates',
        action: 'read',
        icon: 'TrelloIcon'

    },
    {

        title: 'Templates',
        route: 'certificates-templates',
        resource: 'templates',
        action: 'read',
        icon: 'TrelloIcon'

    },
    {

        title: 'Add Grade/Class Results',
        route: 'results-add',
        resource: 'results',
        action: 'create',
        icon: 'TrelloIcon'

    },
    {

        title: 'School Regulations',
        route: 'schoolregulations',
        resource: 'National',
        action: 'read',
        // icon: 'ClassBoardIcon',
        icon: 'TrelloIcon'

    },
    {
        title: 'Subjects',
        route: 'subjects',
        action: 'read',
        resource: 'Analytics',
        icon: 'GridIcon'
    },
    {
        title: 'Complaints and Inqueries',
        route: 'complaints',
        resource: 'complaint',
        action: 'read',
        icon: 'GridIcon'
    },
    {
        title: 'Student Permission',
        route: 'studentpermissions',
        resource: 'studentpermissions',
        action: 'read',
        icon: 'GridIcon'
    },
    {
        title: 'Classes',
        route: 'classes',
        action: 'read',
        resource: 'classes',
        icon: 'GridIcon'
    },
    {
        title: 'Attendance',
        route: 'attendance',
        action: 'write',
        resource: 'Attendance',
        icon: 'TrelloIcon'
    },
    {
        title: 'Qmatics',
        route: 'qmatics',
        action: 'read',
        resource: 'qmatics',
        icon: 'TrelloIcon'
    },
    {
        title: 'Evaluation',
        route: 'evaluation',
        action: 'read',
        resource: 'Evaluation',
        icon: 'TrelloIcon'
    },

    {
        title: 'Grades',
        route: 'grades',
        action: 'read',
        resource: 'Analytics',
        icon: 'GridIcon'
    },
    {
        title: 'Study Materials',
        route: 'studymaterialslist',
        icon: 'BookIcon',
        action: 'read',
        resource: 'ACL',
    },

    {
        title: 'Booklets',
        route: 'booklets',
        icon: 'BookIcon',
        action: 'read',
        resource: 'booklets',
    },
    {

        title: 'Chat-',
        route: 'apps-chat',
        icon: 'MessageSquareIcon',
        action: 'read',
        resource: 'Analytics',

    },
    {
        title: 'Online Exams',
        icon: 'PenToolIcon',
        action: 'read',
        resource: 'ACL',
        // tag: '2',
        // tagVariant: 'light-warning',
        children: [{
                title: 'Exams',
                route: 'exams',
                action: 'read',
                resource: 'ACL',
                icon: 'PenToolIcon'
            },
            {
                title: 'Results',
                route: 'onlineexamresults',
                action: 'read',
                resource: 'ACL',
                icon: 'PenToolIcon'
            },
            {
                title: 'All Results',
                route: 'onlineexamresultsindex',
                action: 'read',
                resource: 'onlineexamresults',
                icon: 'PenToolIcon'
            },
            
        ]
    },
    {
        title: 'Finance',
        icon: 'DollarSignIcon',
        action: 'read_parent_invoices',
        resource: 'ACL',
        children: [

            {
                title: 'Students Invoices',
                route: 'students-invoices',
                action: 'read_parent_invoices',
                resource: 'ACL',
            },
            {
                title: 'New Admission',
                route: 'student-admissions',
                resource: 'ACL',
                action: 'finance_reports',
            },
            {
                title: 'Grades invoices',
                route: 'grades-invoices',
                resource: 'ACL',
                action: 'finance_reports',
            },
            {
                title: 'Reports',
                icon: 'DollarSignIcon',
                resource: 'ACL',
                action: 'finance_reports',
                children: [{
                        title: 'Daily Reports',
                        route: 'financeReports',
                        resource: 'ACL',
                        action: 'finance_reports',
                    }, {
                        title: 'Classes Report',
                        route: 'classes-invoices',
                        resource: 'ACL',
                        action: 'finance_reports',
                    },
                    {
                        title: 'Grades Report',
                        route: 'grades-reports',
                        resource: 'ACL',
                        action: 'finance_reports',
                    },
                ]

            }

        ],
    },
    {
        title: 'Students',
        route: 'students',
        action: 'read',
        resource: 'Students',
    },
    {
        title: 'Users',
        icon: 'UsersIcon',
        action: 'manage',
        resource: 'ALL',
        // tag: '2',
        // tagVariant: 'light-warning',
        children: [{
                title: 'Users',
                route: 'users',
            },
            {
                title: 'Students',
                route: 'students',
            },
            {
                title: 'Teachers',
                route: 'teachers',
            },
            {
                title: 'Parents',
                route: 'parents',
            },
            {
                title: 'Employees',
                route: 'employees',
                icon: 'MessageSquareIcon',
            },
            {
                title: 'Admins',
                route: 'admins',
                icon: 'MessageSquareIcon',
            }, {
                title: 'Accountants',
                route: 'accountants',
            },

            {
                title: 'Stage Admins',
                route: 'stageadmins',
            },
            {
                title: 'Debuties',
                route: 'debuties',
            },
            {
                title: 'Principles',
                route: 'Principles',
            },
            {
                title: 'Gate Class Supervisors',
                route: 'supervisors',
            },
            {
                title: 'Gate Grade Supervisors',
                route: 'gradesupervisors',
            },
            {
                title: 'Head Of Departments',
                route: 'hods',
            },
        ],
    },
    {
        title: 'School Bus',
        icon: 'MapIcon',
        action: 'read',
        resource: 'Analytics',
        // tagVariant: 'light-warning',
        children: [{
                title: 'Bus Tracker',
                route: 'bustracker',
                icon: 'MessageSquareIcon',
                action: 'read',
                resource: 'ACL',
            },

            {
                title: 'Bus Drivers',
                route: 'busdrivers',
            },
            {
                title: 'Bus Supervisors',
                route: 'bussupervisors',
            },
            {
                title: 'Busses',
                route: 'busses',
            },
            {
                title: 'Lines',
                route: 'buslines',
            },

        ],
    },
    {
        title: 'Facial Settings',
        icon: 'ClockIcon',
        action: 'write',
        resource: 'ACL',
        // tagVariant: 'light-warning',
        children: [{
                title: 'Devices',
                route: 'devices',
            },
            {
                title: 'Employee Attendance',
                route: 'empattendance',
            }
        ],
    },

    {
        title: 'Print Cards',
        route: 'printcards',
        action: 'read',
        resource: 'Analytics',
        icon: 'SettingsIcon'
    },
    {
        title: 'Settings',
        route: 'settings',
        action: 'read',
        resource: 'Analytics',
        icon: 'SettingsIcon'
    },

    {
        title: 'Import',
        route: 'imports',
        action: 'read',
        resource: 'Analytics',
        icon: 'UploadIcon'
    },

    {
        title: 'Export',
        route: 'exports',
        action: 'read',
        resource: 'Analytics',
        icon: 'DownloadIcon'
    },
    // {
    //     title: 'School Configuration',
    //     icon: 'HomeIcon',
    //     tag: '2',
    //     tagVariant: 'light-warning',
    //     children: [{
    //             title: 'Subjects',
    //             route: 'subjects',
    //             action: 'read',
    //             resource: 'ACL',
    //         },
    //         {
    //             title: 'Classes',
    //             route: 'classes',
    //         },
    //         {
    //             title: 'Grades',
    //             route: 'grades',
    //             action: 'read',
    //             resource: 'ACL',
    //         },
    //         {
    //             title: 'Study Materials',
    //             route: 'studymaterials',
    //             icon: 'MessageSquareIcon',
    //         }
    //     ],
    // },
    // {
    //     title: 'Student Affairs',
    //     icon: 'HomeIcon',
    //     tag: '2',
    //     tagVariant: 'light-warning',
    //     children: [{
    //             title: 'Attendance',
    //             route: 'students-list',
    //             action: 'read',
    //             resource: 'ACL',
    //         },
    //         {
    //             title: 'Schedule',
    //             route: 'pages-profile',
    //         },
    //         {
    //             title: 'Exam',
    //             route: 'classfeed',
    //             action: 'read',
    //             resource: 'ACL',
    //         },
    //         {
    //             title: 'Announcements',
    //             route: 'apps-chat',
    //             icon: 'MessageSquareIcon',
    //         }
    //     ],
    // },
    // {
    //     title: 'School',
    //     icon: 'HomeIcon',
    //     tag: '2',
    //     tagVariant: 'light-warning',
    //     children: [{
    //             title: 'students',
    //             route: 'students-list',
    //             action: 'read',
    //             resource: 'ACL',
    //         },
    //         {
    //             title: 'Profile',
    //             route: 'pages-profile',
    //         },
    //         {

    //             title: 'Class feed',
    //             route: 'classfeed',
    //             action: 'read',
    //             resource: 'ACL',
    //         },
    //         {
    //             title: 'Chat',
    //             route: 'apps-chat',
    //             icon: 'MessageSquareIcon',
    //         },

    //         {
    //             title: 'Access Control',
    //             route: 'access-control',
    //             icon: 'ShieldIcon',
    //             // acl: {
    //             action: 'read',
    //             resource: 'ACL',
    //             // },
    //         },
    //         {
    //             title: 'Sweet Alert',
    //             route: 'extensions-sweet-alert',
    //         },
    //         {
    //             title: 'Toastification',
    //             route: 'extensions-toastification',
    //         },
    //         {
    //             title: 'ONLINE Classes',
    //             route: 'apps-onlineclass',
    //             icon: 'CheckSquareIcon',
    //         },
    //         // {
    //         //     title: 'eCommerce',
    //         //     route: 'dashboard-ecommerce',
    //         // },
    //         // {
    //         //     title: 'Analytics',
    //         //     route: 'dashboard-analytics',
    //         // },
    //     ],
    // },
]